import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { selectSupportError } from 'redux/user/selector';
import { clearSupportForm } from 'redux/user/actions';

const SupportReqSuccess: React.FC<Props> = (props) => {
  const { unauthenticated } = props;
  const isSupportSubmitError = useSelector(selectSupportError);
  const dispatch: any = useDispatch();
  const history = useHistory();
  return (
    <InlineNotification
      className={`support-request--success success-notification ${
        unauthenticated ? ' unathenticated' : ''
      }`}
      kind={isSupportSubmitError ? 'error' : 'success'}
      lowContrast
      actions={
        <NotificationActionButton
          className="action--button"
          onClick={() => history.push(`https://help.byda.com.au/`)}
        >
          Solutions to common problems
        </NotificationActionButton>
      }
      onCloseButtonClick={() => {
        dispatch(clearSupportForm());
      }}
      iconDescription="Close notification panel"
      subtitle={
        isSupportSubmitError
          ? 'Problem submitting support form, please try again later.'
          : 'A support person will be in touch.'
      }
      title={isSupportSubmitError ? 'Error.' : 'Thanks.'}
    />
  );
};

const propTypes = {
  unauthenticated: PropTypes.bool
};

type Props = PropTypes.InferProps<typeof propTypes>;

SupportReqSuccess.defaultProps = {
  unauthenticated: false
};

SupportReqSuccess.displayName = 'ContactSupportModal';
export default SupportReqSuccess;
